// REF-020 Phase 2 — formatNumber mixin (hot-fix #10, 2026-05-05)
//
// 헤더·사이드바 등 기존 컴포넌트 호환층. 구현은 utils/format-number.js (단일 출처) 에 위임 — TASK-149 (2026-09-20).
// 신규 코드는 mixin 대신 전역 메서드 `$formatNumber(value, digits)` 사용 권장 (import 불필요).

import { formatNumber } from '../../../utils/format-number';

export default {
    methods: {
        formatNumber(value, digits = null) {
            return formatNumber(value, digits);
        },
    },
};
